export default {
  ownerGroup: 'Owner Group',
  warehouseCity: 'Warehouse City',
  shipto: 'Shipto',
  defaultShipto: 'Default Shipto',
  siteType: 'Site Type',
  createTime: 'Create Time',
  updateTime: 'Update Time'
}
